/*
 * BrightLabs Proprietary Limited (c) 2021
 * https://www.brightlabs.co.bw
 * info@brightlabs.co.bw
 */

import React from "react";
import {Stack} from "@fluentui/react";
import Slide from 'react-reveal';

import hero from "../../images/illustrations/services_dev_0365.svg";

import Page from "../shared/Page";
import helpers from "../../k/helpers";
import Hero from "../shared/Hero";
import ServicePage from "../shared/ServicePage";


class HeroContent extends React.Component<any, any> {

    public render() {

        const
            padding = helpers.padding();

        return (
            <Stack tokens={{childrenGap: padding}}>

                <Stack>

                    <Slide left>
                        <Stack tokens={{childrenGap: -16}}>
                            <h4>
                                {helpers.links.services.text}
                            </h4>

                            <h1>
                                {helpers.links.o365_dev.text}
                            </h1>
                        </Stack>
                    </Slide>

                    <Slide right>
                        <h2>
                            We build smarter productivity apps.
                        </h2>
                    </Slide>

                </Stack>

                <Slide bottom>
                    <Stack verticalFill={true} verticalAlign={'center'} horizontalAlign={'center'}>
                        <h3>
                            As a Microsoft Partner, we build solutions that harness the power of the Microsoft 365 platform,
                            to help you expand the reach of your solutions to new customers, partners and markets.<br />
                            We build custom solutions for Office, SharePoint, Teams, Flow, Power BI, Microsoft Graph and Azure.
                        </h3>
                    </Stack>
                </Slide>

            </Stack>
        );
    }
}

class AdditionalContent extends React.Component<any, any> {
    render() {
        return null;
    }
}

export default class O365Dev extends ServicePage {

    public render() {

        const
            backgroundColor = 'rgba(0, 0, 0, 0.003)',
            backgroundSize = '25%',

            title = "BrightLabs | " + helpers.links.o365_dev.text,
            url = helpers.links.o365_dev.url,
            description = "Build smarter productivity apps on Office 365 " +
                "- Office, SharePoint, Teams, Flow, Power BI, Microsoft Graph, Azure";

        return (
            <Page title={title} description={description} url={url}>

                <Hero backgroundColor={backgroundColor} backgroundSize={backgroundSize} hero={hero}>
                    <HeroContent />
                </Hero>

                <AdditionalContent />
            </Page>
        );
    }
}
